import Goodsandservicesgroup from "assets/images/sidebar-icons/Goodsandservicesgroup.svg";
import Goodsandservices from "assets/images/sidebar-icons/Goodsandservices.svg";
import Warehouse from "assets/images/sidebar-icons/Warehouse.svg";
import Warehousemanagement from "assets/images/sidebar-icons/Warehousemanagement.svg";
import measurementunit from "assets/images/sidebar-icons/measurementunit.svg";
import WarehouseEntryDocument from "assets/images/sidebar-icons/WarehouseEntryDocument.svg";
import Warehouseexitdocument from "assets/images/sidebar-icons/Warehouseexitdocument.svg";
import Warehousedocuments from "assets/images/sidebar-icons/Warehousedocuments.svg";
import person from "assets/images/sidebar-icons/person.svg";
import convertRange from "assets/images/sidebar-icons/convert-range.svg";
import prefactor from "assets/images/sidebar-icons/prefactor.svg";
import allPreFactors from "assets/images/sidebar-icons/allPreFactors.svg";
import settingBlack from "assets/images/sidebar-icons/settings-black.svg";
import inventoryOfWareHouse from "assets/images/sidebar-icons/note-on-a-clipboard.svg";
import importExportReport from "assets/images/sidebar-icons/importExportReport.svg";

const sidebarItems = [{
    "title": "مدیریت انبار",
    img: Warehousemanagement,
    "submenu": [{
        "to": "/warehouse/measurement-unit",
        src: measurementunit,
        "name": "واحدهای سنجش"
      },
      {
        "to": "/warehouse/commodity-and-services-group",
        src: Goodsandservicesgroup,
        "name": "گروه های کالایی"
      },
      {
        "to": "/warehouse/create-commodity-and-services",
        src: Goodsandservices,
        "name": "ثبت کالاها"
      },
      {
        "to": "/warehouse/commodity-and-services",
        src: Goodsandservices,
        "name": "نمایش کالا و خدمات"
      },
      {
        "to": "/warehouse/create-warehouse",
        src: Warehouse,
        "name": "انبار ها"
      },
      {
        "to": "/warehouse/inventory-of-warehouse",
        src: inventoryOfWareHouse,
        "name": "موجودی انبار ها"
      },
      {
        "to": "/warehouse/persons",
        src: person,
        "name": "اشخاص"
      },
      {
        "to": "/warehouse/persons-group",
        src: person,
        "name": "گروه اشخاص"
      }
    ]
  },
  {
    "title": "اسناد انبار",
    img: Warehousedocuments,
    "submenu": [{
        "to": "/warehouse/create-warehouse-document/entry",
        src: WarehouseEntryDocument,
        "name": "ثبت سند ورود انبار "
      },
      {
        "to": "/warehouse/create-warehouse-document/exit",
        src: Warehouseexitdocument,
        "name": "ثبت سند خروج انبار"
      },
      {
        "to": "/warehouse/warehouse-documents/entry",
        src: WarehouseEntryDocument,
        "name": "اسناد ورودی انبار"
      },
      {
        "to": "/warehouse/warehouse-documents/exit",
        src: Warehouseexitdocument,
        "name": "اسناد خروجی انبار"
      },
      {
        "to": "/warehouse/summary-of-import-and-export-report",
        src: importExportReport,
        "name": "گزارش تجمیعی"
      }
    ]
  },
  {
    "title": "تبدیل محصولات",
    img: Warehousedocuments,
    "submenu": [{
      "to": "/warehouse/warehouse-convert-docs",
      src: convertRange,
      "name": "اسناد اقلام تبدیل شده"
    }, ]
  },
  // {
  //   "title": "پیش فاکتورها",
  //   img: Warehousedocuments,
  //   "submenu": [{
  //       "to": "/prefaktor/create-prefaktor-document",
  //       src: prefactor,
  //       "name": "ثبت پیش فاکتور "
  //     },
  //     {
  //       "to": "/prefaktor/show-prefaktor-documents",
  //       src: allPreFactors,
  //       "name": "مشاهده پیش فاکتورها"
  //     },
  //     {
  //       "to": "/prefaktor/prefaktor-documents-setting",
  //       src: settingBlack,
  //       "name": "تنظیمات پیش فاکتورها"
  //     },
  //   ]
  // }
];
export default sidebarItems;